module.exports = __webpack_public_path__ + "img/java-task.522f25f7.svg";